(() => {
  const cache = new Map();
  async function search(query, signal) {
    if (cache.has(query)) return cache.get(query);
    const root = window.Shopify?.routes?.root || '/';
    const params = new URLSearchParams({ q: query, section_id: 'ks-search-content', 'resources[type]': 'collection,page,article', 'resources[limit]': '10', 'resources[limit_scope]': 'each', 'resources[options][fields]': 'title,body' });
    const response = await fetch(root + 'search/suggest?' + params, { signal });
    if (!response.ok) throw new Error('Content search unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const results = doc.querySelector('[data-ks-content-results]');
    if (!results) throw new Error('Content search response missing');
    const markup = results.querySelector('a') ? results.outerHTML : '';
    if (cache.size >= 30) cache.delete(cache.keys().next().value);
    cache.set(query, markup);
    return markup;
  }
  window.KsSearchContent = { search };
  function buildCarousel(target, markup) {
    const viewport = target.querySelector('[data-ks-search-related-list]');
    const source = new DOMParser().parseFromString(markup, 'text/html');
    const track = document.createElement('ul');
    track.className = 'ks-search-related__track';
    track.setAttribute('role', 'list');
    source.querySelectorAll('.ks-search-content__group').forEach(group => {
      const type = group.querySelector('.ks-search-content__heading').textContent;
      group.querySelectorAll('.ks-search-content__item').forEach(link => {
        const item = document.createElement('li');
        const title = link.lastElementChild;
        const copy = document.createElement('span');
        copy.className = 'ks-search-related__copy';
        const label = document.createElement('span');
        label.className = 'ks-search-related__type';
        label.textContent = type;
        title.className = 'ks-search-related__name';
        copy.append(label, title);
        link.append(copy);
        item.append(link);
        track.append(item);
      });
    });
    viewport.replaceChildren(track);
    target.hidden = !track.children.length;
    if (target.hidden) return;
    const prev = target.querySelector('[data-ks-related-prev]');
    const next = target.querySelector('[data-ks-related-next]');
    const update = () => {
      prev.disabled = viewport.scrollLeft <= 1;
      next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
    };
    const move = direction => viewport.scrollBy({
      left: direction * Math.max(180, viewport.clientWidth * 0.8),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    prev.onclick = () => move(-1);
    next.onclick = () => move(1);
    viewport.onscroll = update;
    viewport.onkeydown = event => {
      if (event.target !== viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    };
    if (target.ksRelatedObserver) target.ksRelatedObserver.disconnect();
    target.ksRelatedObserver = new ResizeObserver(update);
    target.ksRelatedObserver.observe(viewport);
    update();
  }
  async function loadPageResults() {
    for (const target of document.querySelectorAll('[data-ks-search-related]')) {
      const query = target.dataset.query;
      if (!query) continue;
      try {
        const markup = await search(query);
        buildCarousel(target, markup);
      } catch (_) { target.hidden = true; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadPageResults);
  else loadPageResults();
  document.addEventListener('shopify:section:load', loadPageResults);
})();
